import { Loader2, ShieldOff } from "lucide-react";

export function PageHeader({ eyebrow, title, rgb = "var(--glow-home)", actions, testid }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between q-rise">
      <div className="min-w-0 q-onwall">
        {eyebrow && (
          <div className="mb-2 text-[10px] font-black uppercase tracking-[0.2em]" style={{ color: `rgb(${rgb})`, textShadow: `0 0 14px rgba(${rgb},0.45)` }}>
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-q-text sm:text-4xl break-words" data-testid={testid}>{title}</h1>
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ Icon, title, hint, action, rgb = "var(--glow-home)", testid }) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-dashed border-q-line px-6 py-12 text-center" data-testid={testid}>
      {Icon && (
        <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full" style={{ background: `rgba(${rgb},0.12)` }}>
          <Icon className="h-5 w-5" style={{ color: `rgb(${rgb})` }} />
        </span>
      )}
      <p className="font-display text-lg font-bold text-q-text">{title}</p>
      {hint && <p className="mt-1 max-w-sm text-sm text-q-muted">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-sm text-q-muted" data-testid="loader">
      <Loader2 className="h-4 w-4 animate-spin" /> {label}
    </div>
  );
}

export function NoAccess({ message = "You don't have access to this section", action }) {
  return (
    <div className="mx-auto mt-16 max-w-md text-center q-rise" data-testid="no-access">
      <span className="mx-auto mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full" style={{ background: "rgba(var(--glow-media),0.12)" }}>
        <ShieldOff className="h-6 w-6" style={{ color: "rgb(var(--glow-media))" }} />
      </span>
      <h2 className="font-display text-2xl font-extrabold text-q-text" data-testid="no-access-message">{message}</h2>
      <p className="mt-2 text-sm text-q-muted">Ask a parent in this hub if you think you should see this.</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function StatusPill({ label, rgb, testid }) {
  return (
    <span data-testid={testid} className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-black uppercase tracking-[0.12em]"
      style={{ background: `rgba(${rgb},0.14)`, color: `rgb(${rgb})`, boxShadow: `inset 0 0 0 1px rgba(${rgb},0.35)` }}>
      {label}
    </span>
  );
}

export function Field({ label, error, children, htmlFor, errorTestid }) {
  return (
    <div>
      <label className="q-label" htmlFor={htmlFor}>{label}</label>
      {children}
      {error && <p className="q-error" data-testid={errorTestid}>{error}</p>}
    </div>
  );
}
